import CardIcon from './card-icon.vue';

export default CardIcon;
